










import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { Conversation } from '../types';
import { ConversationType } from '../types';

export default defineComponent({
  name: 'NewChatHeader',
  props: {
    conversation: {
      type: Object as PropType<Conversation>,
      default: undefined,
    },
  },
  setup(props) {
    const title = computed(() =>
      props.conversation.type === ConversationType.General
        ? t('dsr_chat_all_participants')
        : props.conversation.title || t('dsr_chat_header')
    );

    return {
      title,
    };
  },
});
